<template>
  <div v-if="windowLock" class="view-image-wrap" @click="closeWindow">
    <img :src="imgUrl" :alt="title" :title="title" :width="imageWidth" @mousewheel.prevent="rollImage">
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    imgUrl: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      imageWidth: '65%',
      windowLock: false
    };
  },
  mounted() {
  },
  methods: {
    // 关闭弹窗
    closeWindow() {
      this.$emit('update:visible', false);
    },
    // 缩放图片
    rollImage (event) {
      console.log(event);
      let zoom = Number(this.imageWidth) || 60;

      // event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom
      // wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动
      zoom += event.wheelDelta / 12;

      if (zoom >= 40 && zoom < 1500) {
        this.imageWidth = `${zoom}%`;
      }
      return false;
    },
  },
  watch: {
    visible(v) {
      this.windowLock = v;
    }
  }
};
</script>
<style>
  .view-image-wrap{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background: rgba(0,0,0,.8);
  }
  .view-image-wrap img{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    max-height: 90%;
    max-width: 90%;
  }
</style>
